import { __makeTemplateObject } from "tslib";
import { css } from 'styled-components';
import { space } from 'styled-system';
import { getComponentVariant, createComponent } from '../utils';
export var Alert = createComponent({
    name: 'Alert',
    style: function (_a) {
        var variant = _a.variant, theme = _a.theme;
        var variantStyles = variant ? getComponentVariant(theme, 'Alert', variant) : '';
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding: 1rem;\n      margin-bottom: 1rem;\n      border: 0;\n      font-size: 14px;\n      font-family: ", ";\n      border-radius: ", "px;\n\n      a {\n        color: inherit;\n        text-decoration: underline;\n      }\n\n      ", "\n      ", "\n    "], ["\n      padding: 1rem;\n      margin-bottom: 1rem;\n      border: 0;\n      font-size: 14px;\n      font-family: ", ";\n      border-radius: ", "px;\n\n      a {\n        color: inherit;\n        text-decoration: underline;\n      }\n\n      ", "\n      ", "\n    "])), theme.typography.bodyFontFamily || 'inherit', theme.radius, variantStyles, space);
    },
});
Alert.defaultProps = {
    variant: 'primary',
};
var templateObject_1;
//# sourceMappingURL=Alert.js.map